// extracted by mini-css-extract-plugin
export var error = "ContactModal-module--error--8np+I";
export var form = "ContactModal-module--form--Z6VnV";
export var welcomeContent = "ContactModal-module--welcomeContent--q8FXD";